export interface IDashboardRef {
  updateDashboard: () => void;
}

export const DEFAULT_ELEMENT_SIZES = {
  widget: {
    width: 300,
    height: 200,
    maxSize: -1,
  },
};

export type TDataTypes =
  | 'netSales'
  | 'totalRevenue'
  | 'totalDiscount'
  | 'totalSpecials'
  | 'tips'
  | 'voidedItems'
  | 'transactions'
  | 'creditCardType'
  | 'grossSalesGroup'
  | 'netSalesByRole'
  | 'itemsByCategory'
  | 'revenueSummary'
  | 'creditCardSummary'
  | 'discountSummary'
  | 'specialsSummary'
  | 'giftCardSoldSummary'
  | 'tipSummary'
  | 'miscTendersSummary'
  | 'orderSummary'
  | 'specialsDisplay'
  | 'grossSalesGroupDisplay'
  | 'netSalesBreakdownByRole'
  | 'discountBreakdown'
  | 'batchTotals'
  | 'top10ItemsCombos';

export const DATA_TYPES: Record<number, string> = {
  11: 'netSales',
  12: 'totalRevenue',
  13: 'totalDiscount',
  14: 'totalSpecials',
  15: 'tips',
  16: 'voidedItems',
  21: 'transactions',
  22: 'creditCardType',
  23: 'grossSalesGroup',
  24: 'netSalesByRole',
  25: 'itemsByCategory',
  31: 'revenueSummary',
  32: 'creditCardSummary',
  33: 'discountSummary',
  34: 'specialsSummary',
  35: 'giftCardSoldSummary',
  36: 'tipSummary',
  37: 'miscTendersSummary',
  38: 'orderSummary',
  39: 'specialsDisplay',
  40: 'grossSalesGroupDisplay',
  41: 'netSalesBreakdownByRole',
  42: 'discountBreakdown',
  43: 'batchTotals',
  44: 'top10ItemsCombos',
};

export const DATA_TYPES_NAMES: Record<string, number> = {
  netSales: 11,
  totalRevenue: 12,
  totalDiscount: 13,
  totalSpecials: 14,
  tips: 15,
  voidedItems: 16,
  transactions: 21,
  creditCardType: 22,
  grossSalesGroup: 23,
  netSalesByRole: 24,
  itemsByCategory: 25,
  revenueSummary: 31,
  creditCardSummary: 32,
  discountSummary: 33,
  specialsSummary: 34,
  giftCardSoldSummary: 35,
  tipSummary: 36,
  miscTendersSummary: 37,
  orderSummary: 38,
  specialsDisplay: 39,
  grossSalesGroupDisplay: 40,
  netSalesBreakdownByRole: 41,
  discountBreakdown: 42,
  batchTotals: 43,
  top10ItemsCombos: 44,
};

export const DATA_TYPES_PER_WIDGET_TYPE = {
  barChart: [11, 12, 13, 14, 15, 16],
  pieChart: [21, 22, 23, 24, 25],
  dataTable: [31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
};

export const FORM_DATA_INITIAL_STATE: {
  title: string;
  parameters: Record<string, any>;
} = {
  title: '',
  parameters: {
    dataType: DATA_TYPES[11],
    xLabel: '',
    yLabel: '',
    color: '#348DFC',
  },
};

export interface IDashboardFilters {
  timePeriod: TTimePeriodTypes;
  startDate: string;
  endDate: string;
}

export type TTimePeriodTypes =
  | 'today'
  | 'yesterday'
  | 'this_week'
  | 'this_month'
  | 'this_year'
  | 'custom';

export type TDateTypes =
  | 'yesterday'
  | 'today'
  | 'this_week'
  | 'this_month'
  | 'this_year'
  | 'custom';

export const EDateTypes = {
  yesterday: 'yesterday',
  today: 'today',
  this_week: 'this_week',
  this_month: 'this_month',
  this_year: 'this_year',
  custom: 'custom',
};
